module.exports = __webpack_public_path__ + "img/bg_img@2x.553edb07.png";